<form *ngIf="fields && form" [ngClass]="{'invalid-submit': invalidSubmit}" style="padding-left: 20px;" [formGroup]="form" (ngSubmit)="saveOrUpdate()" class="bottom-10-margin" RestrictFocus>
    <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.company_id.nullable}">{{ fields.company_id.keyName }}</label></div>
            <div class="ui-grid-col-8">
                <p-dropdown
                    formControlName="company_id"
                    [options]="companies"
                    [style]="{ 'width': '100%'}"
                ></p-dropdown>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.company_id"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.date_start.nullable}">{{ fields.date_start.keyName }}</label></div>
            <div class="ui-grid-col-8">
                <app-kv-calendar
                    #dateStartField
                    [inputName]="'date_start'"
                    [formData]="form"
                    [defaultDate]="setDefaultDateStart()"
                    [defaultValue]="setDefaultDateStart()"
                    [maxDate]="dateStartMax"
                    [startDateSelector]="true"
                    [endDateInputName]="'date_end'"
                    [endDateCalendar]="dateEndField"
                >
                </app-kv-calendar>
                <span class="input-error-notification" *ngIf="dateStartIssue">{{ 'common.startDateLimit' | translate }}</span>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.date_start"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.date_end.nullable}">{{ fields.date_end.keyName }}</label></div>
            <div class="ui-grid-col-8">
                <app-kv-calendar
                    #dateEndField
                    [inputName]="'date_end'"
                    [formData]="form"
                    [defaultDate]="setDefaultDateEnd()"
                    [defaultValue]="setDefaultDateEnd()"
                    [minDate]="dateEndMin"
                    [endDateSelector]="true"
                    [startDateInputName]="'date_start'"
                    [startDateCalendar]="dateStartField"
                >
                </app-kv-calendar>
                <span class="input-error-notification" *ngIf="dateEndIssue">{{ 'common.endDateLimit' | translate }}</span>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form" [validation]="fields.date_end"></app-validation-msg>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
            <button type="submit"
                    class="k-generic-btn"
                    pButton icon="fa fa-plus"
                    label="{{btntraduction | translate }}"
            ></button>
        </div>
    </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/users/userCompaniesForm.component.html